import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BaseLogin = _resolveComponent("BaseLogin");
  return _openBlock(), _createBlock(_component_BaseLogin, {
    title: _ctx.$t('login.adminTitle'),
    fields: $data.loginFields,
    "submit-text": _ctx.$t('login.submit'),
    "background-key": "adminLoginBkImg",
    "is-admin": true,
    loading: $data.isLoading,
    onSubmit: $options.handleLogin
  }, null, 8, ["title", "fields", "submit-text", "loading", "onSubmit"]);
}